type TraversalGuard = { beforeNavigate: () => boolean; index: number | undefined }
type Restoration = { owner: TraversalGuard; index: number; x: number; y: number }
let activeGuard: TraversalGuard | null = null
let restoration: Restoration | null = null
let restoreFrame: { id: number; owner: TraversalGuard } | null = null
let installed = false

function cancelRestoreFrame(owner?: TraversalGuard) {
  if (!restoreFrame || (owner && restoreFrame.owner !== owner)) return
  cancelAnimationFrame(restoreFrame.id)
  restoreFrame = null
}
function handleTraversal(event: PopStateEvent) {
  const targetIndex: unknown = event.state?.idx
  if (restoration && targetIndex === restoration.index) {
    const pending = restoration
    event.stopImmediatePropagation()
    restoration = null
    cancelRestoreFrame()
    restoreFrame = {
      owner: pending.owner,
      id: requestAnimationFrame(() => {
        restoreFrame = null
        if (activeGuard === pending.owner) window.scrollTo(pending.x, pending.y)
      }),
    }
    return
  }
  const guard = activeGuard
  if (
    !guard ||
    typeof guard.index !== 'number' ||
    typeof targetIndex !== 'number' ||
    guard.index === targetIndex
  )
    return
  if (guard.beforeNavigate()) return
  event.stopImmediatePropagation()
  restoration = { owner: guard, index: guard.index, x: window.scrollX, y: window.scrollY }
  window.history.go(guard.index - targetIndex)
}

/** Install before BrowserRouter: an earlier router listener may synchronously unmount a late guard. */
export function installHistoryTraversalGuard(): () => void {
  if (installed || typeof window === 'undefined') return () => {}
  installed = true
  window.addEventListener('popstate', handleTraversal, true)
  return () => {
    window.removeEventListener('popstate', handleTraversal, true)
    installed = false
    activeGuard = null
    restoration = null
    cancelRestoreFrame()
  }
}

/** Only an active screen owns a guard; without one, all normal history navigation is untouched. */
export function registerHistoryTraversalGuard(beforeNavigate: () => boolean): () => void {
  const guard: TraversalGuard = { beforeNavigate, index: window.history.state?.idx }
  activeGuard = guard
  return () => {
    if (activeGuard === guard) activeGuard = null
    cancelRestoreFrame(guard)
  }
}
